module.exports = __webpack_public_path__ + "static/media/logo-blue.3d6e6d13.png";